(function boostlyNfcVcardBootstrap(root) {
  "use strict";

  var GENERATED_VCARD_PATH_PATTERN = /^\/public\/media\/generated\/vcards\/[0-9a-f]{64}\.vcf$/iu;
  var BOOSTLY_WORKER_HOSTS = {
    "boostly-os-production.boostly-ie.workers.dev": true,
    "boostly-os.boostly-ie.workers.dev": true,
  };

  function text(value) {
    return value === null || value === undefined ? "" : String(value);
  }

  function oneLine(value) {
    return text(value).replace(/\r\n|\r|\n/gu, " ").replace(/\s+/gu, " ").trim();
  }

  function escapeVcardText(value) {
    return text(value)
      .replace(/\\/gu, "\\\\")
      .replace(/\r\n|\r|\n/gu, "\\n")
      .replace(/;/gu, "\\;")
      .replace(/,/gu, "\\,");
  }

  function utf8Length(value) {
    var input = text(value);
    var bytes = 0;
    for (var index = 0; index < input.length; index += 1) {
      var code = input.charCodeAt(index);
      if (code < 0x80) {
        bytes += 1;
      } else if (code < 0x800) {
        bytes += 2;
      } else if (code >= 0xd800 && code <= 0xdbff && index + 1 < input.length) {
        var next = input.charCodeAt(index + 1);
        if (next >= 0xdc00 && next <= 0xdfff) {
          bytes += 4;
          index += 1;
        } else {
          bytes += 3;
        }
      } else {
        bytes += 3;
      }
    }
    return bytes;
  }

  function nextCharacter(input, index) {
    var first = input.charCodeAt(index);
    if (first >= 0xd800 && first <= 0xdbff && index + 1 < input.length) {
      var second = input.charCodeAt(index + 1);
      if (second >= 0xdc00 && second <= 0xdfff) {
        return { character: input.slice(index, index + 2), length: 2 };
      }
    }
    return { character: input.charAt(index), length: 1 };
  }

  function foldVcardLine(value) {
    var input = text(value);
    var segments = [];
    var current = "";
    var currentBytes = 0;
    var limit = 75;

    for (var index = 0; index < input.length;) {
      var next = nextCharacter(input, index);
      var characterBytes = utf8Length(next.character);
      if (current && currentBytes + characterBytes > limit) {
        segments.push(current);
        current = "";
        currentBytes = 0;
        limit = 74;
      }
      current += next.character;
      currentBytes += characterBytes;
      index += next.length;
    }
    segments.push(current);
    return segments.join("\r\n ");
  }

  function splitName(value) {
    var fullName = oneLine(value);
    var parts = fullName ? fullName.split(" ") : [];
    if (parts.length <= 1) {
      return { family: parts[0] || "", given: "" };
    }
    return { family: parts.pop(), given: parts.join(" ") };
  }

  function safeWebUrl(value, baseUrl) {
    var candidate = oneLine(value);
    if (!candidate) return "";
    try {
      var parsed = new root.URL(candidate, baseUrl || "https://boostly.ie/");
      return parsed.protocol === "https:" || parsed.protocol === "http:" ? parsed.href : "";
    } catch (_error) {
      return "";
    }
  }

  function buildVcard(payload, options) {
    var data = payload && typeof payload === "object" ? payload : {};
    var settings = options && typeof options === "object" ? options : {};
    var fullName = oneLine(data.name) || oneLine(data.organisation) || "Contact";
    var structuredName = splitName(fullName);
    var organisation = oneLine(data.organisation);
    var title = oneLine(data.title || data.role);
    var phone = oneLine(data.phone).replace(/^tel:/iu, "");
    var email = oneLine(data.email).replace(/^mailto:/iu, "");
    var website = safeWebUrl(data.website, settings.baseUrl);
    var instagram = safeWebUrl(data.instagram, settings.baseUrl);
    var lines = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      "PRODID:-//Boostly//NFC Profile//EN",
      "N;CHARSET=UTF-8:" + escapeVcardText(structuredName.family) + ";" + escapeVcardText(structuredName.given) + ";;;",
      "FN;CHARSET=UTF-8:" + escapeVcardText(fullName),
    ];

    if (organisation) lines.push("ORG;CHARSET=UTF-8:" + escapeVcardText(organisation));
    if (title) lines.push("TITLE;CHARSET=UTF-8:" + escapeVcardText(title));
    if (phone) lines.push("TEL;TYPE=CELL:" + escapeVcardText(phone));
    if (email) lines.push("EMAIL;TYPE=INTERNET:" + escapeVcardText(email));
    if (website) lines.push("URL;TYPE=WORK:" + website.replace(/\\/gu, "\\\\"));
    if (instagram) lines.push("X-SOCIALPROFILE;TYPE=instagram:" + instagram.replace(/\\/gu, "\\\\"));
    lines.push("END:VCARD");

    return lines.map(foldVcardLine).join("\r\n") + "\r\n";
  }

  function safeFilename(handle, name) {
    var candidate = oneLine(handle || name).toLowerCase();
    if (typeof candidate.normalize === "function") {
      candidate = candidate.normalize("NFKD").replace(/[\u0300-\u036f]/gu, "");
    }
    candidate = candidate.replace(/[^a-z0-9]+/gu, "-").replace(/^-+|-+$/gu, "").slice(0, 80);
    return (candidate || "contact") + ".vcf";
  }

  function isGeneratedVcardUrl(value, baseUrl) {
    try {
      var parsed = new root.URL(value, baseUrl || "https://boostly.ie/");
      return parsed.protocol === "https:"
        && BOOSTLY_WORKER_HOSTS[parsed.hostname.toLowerCase()] === true
        && GENERATED_VCARD_PATH_PATTERN.test(parsed.pathname);
    } catch (_error) {
      return false;
    }
  }

  function makeLocalDownload(vcard) {
    if (typeof root.Blob === "function" && root.URL && typeof root.URL.createObjectURL === "function") {
      var objectUrl = root.URL.createObjectURL(new root.Blob([vcard], { type: "text/vcard;charset=utf-8" }));
      return { href: objectUrl, objectUrl: objectUrl };
    }
    return { href: "data:text/vcard;charset=utf-8," + encodeURIComponent(vcard), objectUrl: "" };
  }

  function releaseSectionDownload(section) {
    var objectUrl = section && section.__boostlyNfcVcardObjectUrl;
    if (objectUrl && root.URL && typeof root.URL.revokeObjectURL === "function") {
      root.URL.revokeObjectURL(objectUrl);
    }
    if (section) section.__boostlyNfcVcardObjectUrl = "";
  }

  function attachSection(section, doc) {
    if (!section || section.getAttribute("data-bnp-vcard-ready") === "true") return false;
    var documentRef = doc || root.document;
    var payloadId = section.getAttribute("data-bnp-vcard-payload");
    var payloadElement = payloadId && documentRef ? documentRef.getElementById(payloadId) : null;
    if (!payloadElement) return false;

    var payload;
    try {
      payload = JSON.parse(payloadElement.textContent || "{}");
    } catch (_error) {
      return false;
    }

    var anchors = Array.prototype.slice.call(section.querySelectorAll('[data-bnp-contact-download="true"]'));
    var baseUrl = root.location && root.location.href ? root.location.href : "https://boostly.ie/";
    var generatedAnchors = anchors.filter(function filterGenerated(anchor) {
      var source = anchor.getAttribute("data-bnp-vcard-source") || anchor.getAttribute("href") || "";
      return isGeneratedVcardUrl(source, baseUrl);
    });
    if (!generatedAnchors.length) {
      section.setAttribute("data-bnp-vcard-ready", "true");
      return false;
    }

    releaseSectionDownload(section);
    var download = makeLocalDownload(buildVcard(payload, { baseUrl: baseUrl }));
    var filename = safeFilename(payload.handle, payload.name);
    generatedAnchors.forEach(function prepareAnchor(anchor) {
      anchor.setAttribute("href", download.href);
      anchor.setAttribute("download", filename);
      anchor.setAttribute("data-bnp-local-vcard", "true");
      anchor.removeAttribute("aria-disabled");
      anchor.removeAttribute("target");
      anchor.removeAttribute("rel");
    });
    section.__boostlyNfcVcardObjectUrl = download.objectUrl;
    section.setAttribute("data-bnp-vcard-ready", "true");
    return true;
  }

  function initialise(doc) {
    if (!doc) return;
    Array.prototype.forEach.call(doc.querySelectorAll(".bnp-page[data-bnp-vcard-payload]"), function attach(section) {
      attachSection(section, doc);
    });
  }

  function profileSectionWithin(target) {
    if (target && target.matches && target.matches(".bnp-page[data-bnp-vcard-payload]")) return target;
    if (target && target.querySelector) return target.querySelector(".bnp-page[data-bnp-vcard-payload]");
    return null;
  }

  var api = {
    attachSection: attachSection,
    buildVcard: buildVcard,
    escapeVcardText: escapeVcardText,
    foldVcardLine: foldVcardLine,
    initialise: initialise,
    isGeneratedVcardUrl: isGeneratedVcardUrl,
    safeFilename: safeFilename,
    utf8Length: utf8Length,
  };

  root.BoostlyNfcVcard = api;
  if (typeof module === "object" && module.exports) module.exports = api;

  if (root.document && !root.__boostlyNfcVcardBooted) {
    root.__boostlyNfcVcardBooted = true;
    if (root.document.readyState === "loading") {
      root.document.addEventListener("DOMContentLoaded", function onReady() { initialise(root.document); }, { once: true });
    } else {
      initialise(root.document);
    }
    root.document.addEventListener("shopify:section:load", function onSectionLoad(event) {
      var section = profileSectionWithin(event.target);
      if (section) attachSection(section, root.document);
    });
    root.document.addEventListener("shopify:section:unload", function onSectionUnload(event) {
      var section = profileSectionWithin(event.target);
      if (section) releaseSectionDownload(section);
    });
  }
})(typeof globalThis !== "undefined" ? globalThis : this);
